import React, { useState } from 'react';
import { Image, Space } from 'antd';
import {
  LeftOutlined,
  RightOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  UndoOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './ImagePreview.module.scss';

const cx = classNames.bind(styles);

function ImagePreview({ images = [], size = 120 }) {
  const [preview, setPreview] = useState({
    visible: false,
    index: 0,
  });

  const sliceNumber = 5;
  const imagesMore = images.slice(sliceNumber);

  const handleImageClick = (index) => {
    setPreview({
      visible: true,
      index,
    });
  };

  const handleOverlayClick = (index) => {
    setPreview({
      visible: true,
      index,
    });
  };

  return (
    <div style={{ '--size': size }}>
      <div className={cx('ImagePreview')}>
        {images.slice(0, sliceNumber).map((url, i) => (
          <button
            type="button"
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            onClick={() => handleImageClick(i)}
            className={cx('ImageButton')}
          >
            <img
              alt=""
              width={120}
              src={url}
              className={cx('Image')}
            />

            {imagesMore.length > 0 && i === sliceNumber - 1 && (
              <button
                type="button"
                onClick={() => handleOverlayClick(i + sliceNumber)}
                className={cx('OverlayButton')}
              >
                +
                {imagesMore.length}
              </button>
            )}
          </button>
        ))}
      </div>

      <div style={{ height: 0 }}>
        <Image.PreviewGroup
          preview={{
            zIndex: 99999,
            visible: preview.visible,
            current: preview.index,
            onVisibleChange: (visible) =>
              setPreview((p) => ({ ...p, visible })),
            onChange: (index) =>
              setPreview((p) => ({ ...p, index })),
            actionsRender: (
              _,
              {
                transform: { scale },
                actions: {
                  onActive,
                  onFlipY,
                  onFlipX,
                  onRotateLeft,
                  onRotateRight,
                  onZoomOut,
                  onZoomIn,
                  onReset,
                },
              },
            ) => (
              <Space size={12} className="toolbar-wrapper">
                <LeftOutlined
                  disabled={preview.index === 0}
                  onClick={() => onActive?.(-1)}
                />
                <RightOutlined
                  disabled={preview.index === images.length - 1}
                  onClick={() => onActive?.(1)}
                />
                <SwapOutlined rotate={90} onClick={onFlipY} />
                <SwapOutlined onClick={onFlipX} />
                <RotateLeftOutlined onClick={onRotateLeft} />
                <RotateRightOutlined onClick={onRotateRight} />
                <ZoomOutOutlined
                  disabled={scale === 1}
                  onClick={onZoomOut}
                />
                <ZoomInOutlined
                  disabled={scale === 50}
                  onClick={onZoomIn}
                />
                <UndoOutlined onClick={onReset} />
              </Space>
            ),
          }}
        >
          {images.map((url, i) => (
            <Image
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              src={url}
              className={cx('HiddenImage')}
            />
          ))}
        </Image.PreviewGroup>
      </div>
    </div>
  );
}

ImagePreview.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  size: PropTypes.number,
};

ImagePreview.defaultProps = {
  images: [],
  size: 120,
};

export default ImagePreview;
